export const TEXT_CONTENT = {
  SIDE_MENU: {
    FIXED_ASSET_LEDGER: '固定資産管理台帳',
    MANAGEMENT_SEAL_REQUEST: '管理タグ要求',
    PROGRESS_REVIEW: '進捗確認',
    NX_INTEGRATION: 'NX連携',
    MASTER_DATA: 'マスタデータ',
    USER_MASTER_LIST: 'ユーザーマスタ一覧',
    COMPANY_MASTER_LIST: '会社マスタ一覧',
    DISTRICT_MASTER_LIST: '地区マスタ一覧',
    STORE_MASTER_LIST: '店舗マスタ一覧',
  },
  SIDE_MENU_EN: {
    FIXED_ASSET_LEDGER: 'Fixed Asset Ledger',
    MANAGEMENT_SEAL_REQUEST: 'Management Seal Request',
    PROGRESS_REVIEW: 'Progress Review',
    NX_INTEGRATION: 'NX Integration',
    MASTER_DATA: 'Master Data',
    USER_MASTER_LIST: 'User Master List',
    COMPANY_MASTER_LIST: 'Company Master List',
    DISTRICT_MASTER_LIST: 'District Master List',
    STORE_MASTER_LIST: 'Store Master List',
  },
};
